module.exports = __webpack_public_path__ + "media/images/redesign_apps/play-472c258d272ad3124d351a93cb5880e9.png";